import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import { List, ListItem } from '@mui/material';
import { EnumLeftPanelTabs } from '@types';
import { getStorageItem } from 'helpers';
import { Link, Typography } from 'ui-kit';

import logo from './logo.jpg';
import { ListItemButtonWrapper, Wrapper } from './styles';

export const LeftPanel = () => {
    const { t } = useTranslation();

    const [searchParams, setSearchParams] = useSearchParams();
    const currentParams = Object.fromEntries([...searchParams]);

    const menu: string[] = getStorageItem('menu') || [];

    const handleTabChange = (tab: string) => {
        setSearchParams({ ...currentParams, tab });
    };

    return (
        <Wrapper
            variant="permanent"
            open
        >
            <Link
                href="/"
                sx={{ display: 'flex', justifyContent: 'center', backgroundColor: '#000' }}
            >
                <img
                    src={logo}
                    alt="logo"
                    width={60}
                    height={60}
                />
            </Link>
            <List sx={{ p: 0 }}>
                {menu.concat(EnumLeftPanelTabs.SETTINGS).map((tab: string) => {
                    const convertedTab = tab.toLowerCase().replaceAll(' ', '-');

                    return (
                        <ListItem
                            key={tab}
                            disablePadding
                            sx={{ display: 'block' }}
                            className={currentParams.tab === convertedTab ? 'listItem-active' : 'listItem'}
                        >
                            <ListItemButtonWrapper
                                selected={currentParams.tab === convertedTab}
                                sx={{
                                    minHeight: 40,
                                    px: 2,
                                    justifyContent: 'flex-start',
                                    alignItems: 'center',
                                }}
                                onClick={() => {
                                    handleTabChange(convertedTab);
                                }}
                            >
                                <Typography variant="body2">{t(convertedTab)}</Typography>
                            </ListItemButtonWrapper>
                        </ListItem>
                    );
                })}
            </List>
        </Wrapper>
    );
};
